/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ResendVerificationMutationRequest,
  ResendVerificationMutationResponse,
} from '../types/ResendVerification'

function getResendVerificationUrl() {
  const res = { method: 'POST', url: `/api/v1/resend-verification/` as const }
  return res
}

/**
 * @description request for validation email sending
 * @summary Resend the email-verification message
 * {@link /api/v1/resend-verification/}
 */
export async function resendVerification(
  data: ResendVerificationMutationRequest,
  config: Partial<RequestConfig<ResendVerificationMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ResendVerificationMutationResponse,
    ResponseErrorConfig<Error>,
    ResendVerificationMutationRequest
  >({
    method: 'POST',
    url: getResendVerificationUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
